import React from 'react';
import App from "./components/app";
import { createRoot } from 'react-dom/client';


createRoot(document.getElementById('root')).render(<App />);